import {defaultShouldDehydrateMutation} from '@tanstack/react-query';
import {PersistQueryClientProvider} from '@tanstack/react-query-persist-client';
import {memo} from 'react';
import {Outlet} from 'react-router';

import {createPersister, queryClient} from '#queries';
import {PERSISTED_QUERIES} from '#queries/config.js';
import {NOOP_PERSISTER, QUERY_CLIENT_MAX_AGE} from '#queries/constants.js';
import {shouldPersistMutation, shouldPersistQuery} from '#queries/utils.js';
import {useSessionStore} from '#stores/session/index.js';
import {useFlywheelRouterProxy} from '#utils/lit.js';

const persister = createPersister();

const RouterProxyOutlet = memo(function RouterProxyOutlet() {
  useFlywheelRouterProxy();

  return <Outlet />;
});

export function App() {
  const session = useSessionStore(s => s.session);
  const buster = session
    ? `${session.user.id}:${session.organization.id}:${session.team.id}`
    : undefined;

  return (
    <PersistQueryClientProvider
      client={queryClient}
      persistOptions={{
        persister: session ? persister : NOOP_PERSISTER,
        buster,
        maxAge: QUERY_CLIENT_MAX_AGE,
        dehydrateOptions: {
          shouldDehydrateMutation: mutation =>
            defaultShouldDehydrateMutation(mutation) &&
            shouldPersistMutation(mutation),
          shouldDehydrateQuery: query =>
            query.state.status === 'success' &&
            shouldPersistQuery(query.queryKey as unknown[], PERSISTED_QUERIES),
        },
      }}
    >
      <RouterProxyOutlet />
    </PersistQueryClientProvider>
  );
}
